module.exports = __webpack_public_path__ + "static/media/logo_reference.e465b640.png";